import { Box, Tab, Tabs } from '@mui/material';

function ArrowError({ children }) {
  const sx = {
    width: '20px',
    height: '20px',
    borderRadius: '10px',
    backgroundColor: '#FF0000',
    fontSize: '12px',
    color: '#ffffff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ml: 1,
  };
  return <Box sx={sx}>{children}</Box>;
}

export function ArrowTabGroup(props) {
  return (
    <Tabs
      variant="fullWidth"
      scrollButtons="auto"
      textColor="inherit"
      TabIndicatorProps={{
        style: {
          display: 'none',
        },
      }}
      sx={{
        backgroundColor: 'primary.light',
        borderRadius: 1,
        minHeight: '20px',
      }}
      {...props}>
      {props?.children}
    </Tabs>
  );
}

function ArrowTab(props) {
  const {
    label,
    selected,
    value,
    maxTabs,
    arrowHeadArea = 92,
    arrowBackArea = 8,
    errorCount = null,
    ...other
  } = props;

  // const errorCount = props;

  const firstClipPath = `polygon(0% 0%, 85% 0%, ${arrowHeadArea}% 50%, 85% 100%, 0% 100%)`;
  const lastClipPath = `polygon(0% 0%, ${arrowBackArea}% 50%, 0% 100%, 100% 100%, 100% 0%)`;
  const middleClipPath =
    'polygon(0% 0%, 10% 50%, 0% 100%, 85% 100%, 95% 50%, 85% 0%)';
  let clipPath = middleClipPath;
  if (value === 0) {
    clipPath = firstClipPath;
  } else if (value === maxTabs - 1) {
    clipPath = lastClipPath;
  }

  const commonstyles = {
    minHeight: '40px',
    padding: '0 8px',
    lineHeight: '10px',
    height: '40px',
    cursor: 'pointer',
  };

  return (
    <Tab
      label={
        <Box sx={{ fontWeight: 'normal', fontSize: '1em' }}>
          {label}
          {errorCount && <ArrowError>{errorCount}</ArrowError>}
        </Box>
      }
      selected={selected}
      value={value}
      sx={
        selected
          ? {
              bgcolor: 'primary.main',
              color: 'white',
              clipPath,
              ...commonstyles,
            }
          : {
              ...commonstyles,
            }
      }
      {...other}
    />
  );
}

export default ArrowTab;
